import React from 'react';

type Props = {
  onClick: () => void;
  onPause?: () => void;
  loading?: boolean;
  pausable?: boolean;
  disabled?: boolean;
};

export const SendButton: React.FC<Props> = React.memo(
  ({ onClick, onPause, loading, pausable, disabled }) => {
    const pauseActive = Boolean(loading && pausable && onPause);
    return (
      <button
        type="button"
        className={`rich-text-editor-send-button${pauseActive ? ' rich-text-editor-send-button--pause' : ''}`}
        data-testid="rte-send-button"
        aria-label={pauseActive ? '暂停生成' : loading ? '生成中' : '发送'}
        onClick={pauseActive ? onPause : onClick}
        disabled={disabled || Boolean(loading && !pauseActive)}
      >
        {pauseActive ? (
          <span className="rte-pause-icon" aria-hidden="true" />
        ) : loading ? (
          <span className="rte-send-spinner" />
        ) : (
          <i className="iconfont icon-fasong" />
        )}
      </button>
    );
  },
);
SendButton.displayName = 'SendButton';
